import { PRIMARY_BUTTON } from './result.const';
import { ResultLayout, SuccessIllustration } from './ResultLayout';

/** The answer to a test registration: every check passed and nothing was created. */
export function DryRunResult({ onBack }: Readonly<{ onBack: () => void }>) {
  return (
    <ResultLayout>
      <SuccessIllustration alt="Test registration passed" />

      <h1 className="mt-6 text-center text-2xl font-bold text-gray-900">
        Test registration OK
      </h1>
      <p className="mt-2 text-center text-sm text-gray-500">
        Every check passed. No account was created and you are not signed in.
      </p>

      <button
        type="button"
        onClick={onBack}
        className={`mt-8 ${PRIMARY_BUTTON}`}
      >
        Back to Create account
      </button>
    </ResultLayout>
  );
}
